import axios from 'axios';

export default {
  namespaced: true,
  state: {
    type: 'charge',
    time: '1',
    notices: {
      id: ''
    },
    mapinfo: {
      'charge': [
        {
          'name': '北京',
          'value': 76,
          'info': {
            'captrue': 16,
            'actual': 339808,
            'receivable': 9003812
          }
        },
        {
          'name': '天津',
          'value': 47,
          'info': {
            'captrue': 47,
            'actual': 6725237,
            'receivable': 3634739
          }
        },
        {
          'name': '河北',
          'value': 77,
          'info': {
            'captrue': 85,
            'actual': 5618841,
            'receivable': 594546
          }
        },
        {
          'name': '山西',
          'value': 47,
          'info': {
            'captrue': 68,
            'actual': 703902,
            'receivable': 7874296
          }
        },
        {
          'name': '内蒙古',
          'value': 30,
          'info': {
            'captrue': 20,
            'actual': 5469823,
            'receivable': 2461078
          }
        },
        {
          'name': '辽宁',
          'value': 74,
          'info': {
            'captrue': 16,
            'actual': 8589134,
            'receivable': 3907306
          }
        },
        {
          'name': '上海',
          'value': 12,
          'info': {
            'captrue': 59,
            'actual': 3693535,
            'receivable': 8036303
          }
        },
        {
          'name': '浙江',
          'value': 57,
          'info': {
            'captrue': 89,
            'actual': 4738176,
            'receivable': 8912689
          }
        },
        {
          'name': '河南',
          'value': 36,
          'info': {
            'captrue': 86,
            'actual': 4337278,
            'receivable': 3700790
          }
        },
        {
          'name': '湖南',
          'value': 46,
          'info': {
            'captrue': 19,
            'actual': 2432226,
            'receivable': 2662713
          }
        },
        {
          'name': '广东',
          'value': 23,
          'info': {
            'captrue': 43,
            'actual': 1813135,
            'receivable': 5977607
          }
        },
        {
          'name': '重庆',
          'value': 49,
          'info': {
            'captrue': 40,
            'actual': 4024251,
            'receivable': 860050
          }
        },
        {
          'name': '四川',
          'value': 83,
          'info': {
            'captrue': 26,
            'actual': 3650740,
            'receivable': 5687410
          }
        },
        {
          'name': '陕西',
          'value': 100,
          'info': {
            'captrue': 71,
            'actual': 6640839,
            'receivable': 960997
          }
        },
        {
          'name': '甘肃',
          'value': 42,
          'info': {
            'captrue': 28,
            'actual': 8429998,
            'receivable': 3759352
          }
        }
      ],
      'report': [
        {
          'name': '北京',
          'value': 86,
          'info': {
            'timely': 19,
            'standard': 3473172,
            'reporting': 4550512
          }
        },
        {
          'name': '天津',
          'value': 32,
          'info': {
            'timely': 86,
            'standard': 7954717,
            'reporting': 3159460
          }
        },
        {
          'name': '河北',
          'value': 30,
          'info': {
            'timely': 23,
            'standard': 9483908,
            'reporting': 5209195
          }
        },
        {
          'name': '山西',
          'value': 71,
          'info': {
            'timely': 61,
            'standard': 2292130,
            'reporting': 6261771
          }
        },
        {
          'name': '内蒙古',
          'value': 48,
          'info': {
            'timely': 44,
            'standard': 8492142,
            'reporting': 1703492
          }
        },
        {
          'name': '辽宁',
          'value': 2,
          'info': {
            'timely': 65,
            'standard': 7697692,
            'reporting': 8703076
          }
        },
        {
          'name': '上海',
          'value': 17,
          'info': {
            'timely': 90,
            'standard': 1878338,
            'reporting': 8773683
          }
        },
        {
          'name': '浙江',
          'value': 30,
          'info': {
            'timely': 1,
            'standard': 6365109,
            'reporting': 5212329
          }
        },
        {
          'name': '河南',
          'value': 97,
          'info': {
            'timely': 54,
            'standard': 5403971,
            'reporting': 1916957
          }
        },
        {
          'name': '湖南',
          'value': 13,
          'info': {
            'timely': 17,
            'standard': 3914683,
            'reporting': 2947338
          }
        },
        {
          'name': '广东',
          'value': 17,
          'info': {
            'timely': 19,
            'standard': 1429259,
            'reporting': 2047909
          }
        },
        {
          'name': '重庆',
          'value': 18,
          'info': {
            'timely': 65,
            'standard': 9267111,
            'reporting': 391763
          }
        },
        {
          'name': '四川',
          'value': 30,
          'info': {
            'timely': 77,
            'standard': 4402363,
            'reporting': 9196907
          }
        },
        {
          'name': '陕西',
          'value': 53,
          'info': {
            'timely': 3,
            'standard': 168381,
            'reporting': 6715067
          }
        },
        {
          'name': '甘肃',
          'value': 78,
          'info': {
            'timely': 47,
            'standard': 2630307,
            'reporting': 8931505
          }
        }
      ],
      'housekeeper': [
        {
          'name': '北京',
          'value': 35796,
          'info': {
            'xdonline': 33737,
            'dayonline': 262005
          }
        },
        {
          'name': '天津',
          'value': 41599,
          'info': {
            'xdonline': 24058,
            'dayonline': 157680
          }
        },
        {
          'name': '河北',
          'value': 1659,
          'info': {
            'xdonline': 31575,
            'dayonline': 11498
          }
        },
        {
          'name': '山西',
          'value': 17362,
          'info': {
            'xdonline': 8228,
            'dayonline': 199687
          }
        },
        {
          'name': '内蒙古',
          'value': 5439,
          'info': {
            'xdonline': 41179,
            'dayonline': 290187
          }
        },
        {
          'name': '辽宁',
          'value': 21606,
          'info': {
            'xdonline': 7670,
            'dayonline': 117120
          }
        },
        {
          'name': '上海',
          'value': 1711,
          'info': {
            'xdonline': 6094,
            'dayonline': 103199
          }
        },
        {
          'name': '浙江',
          'value': 46510,
          'info': {
            'xdonline': 38245,
            'dayonline': 152358
          }
        },
        {
          'name': '河南',
          'value': 14761,
          'info': {
            'xdonline': 7466,
            'dayonline': 113341
          }
        },
        {
          'name': '湖南',
          'value': 21502,
          'info': {
            'xdonline': 218,
            'dayonline': 187009
          }
        },
        {
          'name': '广东',
          'value': 39800,
          'info': {
            'xdonline': 9196,
            'dayonline': 12392
          }
        },
        {
          'name': '重庆',
          'value': 47052,
          'info': {
            'xdonline': 44313,
            'dayonline': 259926
          }
        },
        {
          'name': '四川',
          'value': 14288,
          'info': {
            'xdonline': 35873,
            'dayonline': 18945
          }
        },
        {
          'name': '陕西',
          'value': 32605,
          'info': {
            'xdonline': 2400,
            'dayonline': 27535
          }
        },
        {
          'name': '甘肃',
          'value': 18098,
          'info': {
            'xdonline': 45331,
            'dayonline': 194192
          }
        }
      ],
      'money': [
        {
          'name': '北京',
          'value': 7161936,
          'info': {
            'orders': 32329,
            'ordercomplete': 60411,
            'ordercompletemoney': 1786675
          }
        },
        {
          'name': '天津',
          'value': 1707617,
          'info': {
            'orders': 99289,
            'ordercomplete': 71522,
            'ordercompletemoney': 7374882
          }
        },
        {
          'name': '河北',
          'value': 9069299,
          'info': {
            'orders': 98878,
            'ordercomplete': 23580,
            'ordercompletemoney': 2219006
          }
        },
        {
          'name': '山西',
          'value': 186256,
          'info': {
            'orders': 68447,
            'ordercomplete': 61641,
            'ordercompletemoney': 3782192
          }
        },
        {
          'name': '内蒙古',
          'value': 7949273,
          'info': {
            'orders': 49014,
            'ordercomplete': 24530,
            'ordercompletemoney': 6548132
          }
        },
        {
          'name': '辽宁',
          'value': 531845,
          'info': {
            'orders': 29712,
            'ordercomplete': 39282,
            'ordercompletemoney': 5161980
          }
        },
        {
          'name': '上海',
          'value': 7373541,
          'info': {
            'orders': 20430,
            'ordercomplete': 29659,
            'ordercompletemoney': 2273061
          }
        },
        {
          'name': '浙江',
          'value': 7887700,
          'info': {
            'orders': 26940,
            'ordercomplete': 98888,
            'ordercompletemoney': 3873249
          }
        },
        {
          'name': '河南',
          'value': 9919419,
          'info': {
            'orders': 13379,
            'ordercomplete': 27448,
            'ordercompletemoney': 3556382
          }
        },
        {
          'name': '湖南',
          'value': 4580091,
          'info': {
            'orders': 39905,
            'ordercomplete': 36541,
            'ordercompletemoney': 4796768
          }
        },
        {
          'name': '广东',
          'value': 182213,
          'info': {
            'orders': 25738,
            'ordercomplete': 7956,
            'ordercompletemoney': 7112335
          }
        },
        {
          'name': '重庆',
          'value': 6268060,
          'info': {
            'orders': 57348,
            'ordercomplete': 71887,
            'ordercompletemoney': 2368663
          }
        },
        {
          'name': '四川',
          'value': 9627737,
          'info': {
            'orders': 855,
            'ordercomplete': 75965,
            'ordercompletemoney': 2976955
          }
        },
        {
          'name': '陕西',
          'value': 7172219,
          'info': {
            'orders': 1640,
            'ordercomplete': 89729,
            'ordercompletemoney': 2302760
          }
        },
        {
          'name': '甘肃',
          'value': 9293788,
          'info': {
            'orders': 15282,
            'ordercomplete': 43198,
            'ordercompletemoney': 7531706
          }
        }
      ]
    }
  },
  getters: {
    double: ({ count }) => 2 * count,
  },
  mutations: {
    add(state, { count }) {
      state.count += count;
    },
    mapinfo(state, { data }) {
      state.mapinfo = data.data;
    },
    notice(state, { data }) {
      state.notices = data;
    },
    changeTypes(state, type) {
      state.type = type;
    },
    changeTime(state, time) {
      state.time = time;
    }
  },
  actions: {
    getMapInfo({ commit }, params = {}) {
      return axios.get('/home/ajax/mapinfo', {
        params: params[0],
      }).then((data) => {
        commit({ type: 'mapinfo', data: data });
        params[1] && params[1](data);
      });
    },
    getHome({ commit }, params = {}) {
      return axios.get('/home/ajax/home', {
        params: params[0],
        cache: true,
      }).then((data) => {
        params[1] && params[1](data);
      });
    },
    getNotice({ commit }, params = {}) {
      return axios.get('/home/ajax/notice', {
        params: params,
        cache: true,
      }).then((data) => {
        commit({ type: 'notice', data: data.data });
        return data;
      });
    },
    getBaseData({ commit }, params = {}) {
      return axios.get('/home/ajax/getHomeBaseData', {
        params: params,
      }).then((data) => {
        // commit({ type: 'basedata', data: data });
        return data;
      });
    },
    getMapProperty({ commit }, params = {}) {
      return axios.get('/home/ajax/getPropertyMap', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    getMapMatter({ commit }, params = {}) {
      return axios.get('/home/ajax/getMatterMap', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    getMapActive({ commit }, params = {}) {
      return axios.get('/home/ajax/getActiveMap', {
        params: params,
      }).then((data) => {
        return data;
      });
    }
  }
};
